// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPublicKeyDto
 */
export interface IPublicKeyDto {
    /**
     * 
     * @type {string}
     * @memberof IPublicKeyDto
     */
    alias?: string;
    /**
     * 
     * @type {string}
     * @memberof IPublicKeyDto
     */
    key_base64?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof IPublicKeyDto
     */
    supported_encryption_algorithms?: Array<string>;
}

/**
 * Check if a given object implements the IPublicKeyDto interface.
 */
export function instanceOfIPublicKeyDto(value: object): value is IPublicKeyDto {
    return true;
}

export function IPublicKeyDtoFromJSON(json: any): IPublicKeyDto {
    return IPublicKeyDtoFromJSONTyped(json, false);
}

export function IPublicKeyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPublicKeyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'alias': json['alias'] == null ? undefined : json['alias'],
        'key_base64': json['key_base64'] == null ? undefined : json['key_base64'],
        'supported_encryption_algorithms': json['supported_encryption_algorithms'] == null ? undefined : json['supported_encryption_algorithms'],
    };
}

export function IPublicKeyDtoToJSON(json: any): IPublicKeyDto {
    return IPublicKeyDtoToJSONTyped(json, false);
}

export function IPublicKeyDtoToJSONTyped(value?: IPublicKeyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'alias': value['alias'],
        'key_base64': value['key_base64'],
        'supported_encryption_algorithms': value['supported_encryption_algorithms'],
    };
}

